export const DELAY_TO_HIDE_HEADER = 100;
export const DELAY_TO_RESTORE_POSITION = 2000;
